// @flow
import React from 'react';

type Props = {
  branch: string,
  commit: string
};

export default class GitCommitNotFoundWarning extends React.PureComponent<Props> {
  render() {
    return (
      <div className="alert alert-info mb2" role="alert">
        <p>
          {`Git checkout failed as commit ${this.props.commit} could not be found in branch ${this.props.branch}`}
        </p>
      </div>
    );
  }
}
